import { RecoveryBlocEventPayloads, RecoveryBlocActionPayloads } from './../models/recovery-bloc.model';
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { EventsOrActionsOf, GenericBlocService } from 'src/app/shared/services/generic-bloc.service';
import { RecoveryService } from '../../services/recovery.service';
import { RecoveryBlocEvent, RecoveryBlocAction } from '../models/recovery-bloc.model';

@Injectable()
export class RecoveryBlocService extends GenericBlocService<RecoveryBlocEventPayloads, RecoveryBlocActionPayloads> {
  recoveryService = inject(RecoveryService);

  constructor() {
    super();
    this.events$.subscribe((event) => this.onEventEmission(event));
  }

  onEventEmission(event: EventsOrActionsOf<RecoveryBlocEventPayloads>) {
    switch (event.name) {
      case RecoveryBlocEvent.changePassword:
        this.changePassword(event.payload.password, event.payload.confirmPassword, event.payload.id);
        break;
    }
  }

  changePassword(password: string, confirmPassword: string, id: string) {
    this.recoveryService.changePassword(id, password, confirmPassword).subscribe({
      next: (_) => this.addAction(RecoveryBlocAction.passwordChanged, {}),
      error: (error: HttpErrorResponse) => this.addAction(RecoveryBlocAction.passwordChangedFailed, { error }),
    });
  }
}
